module.exports = __webpack_public_path__ + "static/media/tornado.e74e1aa9.svg";